import {
  addWordToDictionary,
  deleteWordFromDictionary,
  getPersonalDictionary,
  updateDictionary,
} from "../../../../services/dictionary";
import ListWithPagination, {
  ITEMS_PER_PAGE,
} from "../../../ListWithPagination/ListWithPagination";
import SelectionBehaviour from "./../../../SelectionBehaviour/SelectionBehaviour";
import TranslationTool from "./components/TranslationTool/TranslationTool";
import DictionaryItem from "./components/DictionaryItem/DictionaryItem";
import bookmarkFilledImg from "../../../../images/bookmark-filled.svg";
import { AddWord, SaveWords } from "./components/SavedWords/SaveWords";
import TalaeraSpinner from "./../../../TalaeraSpinner/TalaeraSpinner";
import filterListImg from "../../../../images/filter_list.svg";
import { ReactComponent as ExpandMoreIcon } from "../../../../images/expand_more.svg";
import { getErrorComponents } from "../../../../services/util";
import Action from "./../../../formElements/Action/Action";
import bookmarkImg from "../../../../images/bookmark.svg";
import { logError } from "../../../../services/logging";
import { Box, Menu, MenuItem } from "@material-ui/core";
import { DictionaryMode } from "../../DictionaryTools";
import addIcon from "../../images/add_circle.svg";
import quizIcon from "../../images/quiz.svg";
import closeImg from "../../images/close.svg";
import "./DictionaryToolsResultPanel.css";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { Trans, Translation } from "react-i18next";

const IDS_TO_SORTING = {
  newest: { sorting: { order_by: "created", sort: "desc" }, name: "Tool.Newest" },
  oldest: { sorting: { order_by: "created", sort: "asc" }, name: "Tool.Oldest" },
  alpha: { sorting: { order_by: null, sort: "asc" }, name: "A - Z" },
  alpha_desc: { sorting: { order_by: null, sort: "desc" }, name: "Z - A" },
};

let timerId = null;

export default class DictionaryToolsResultPanel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      translationState: {},
      addTab: false,
      dropdownOpen: false,
      wordsList: [],
      page: 1,
      totalCount: 0,
      error: null,
      loading: false,
      anchorEl: null,
      selectedPanelId: null,
      sort: "desc",
      order_by: "created",
      selectedSort: "newest",
      deletedWord: null,
      openDeletePopup: false,
    };

    this.onModeChanged = this.onModeChanged.bind(this);
    this.onChangePanel = this.onChangePanel.bind(this);
    this.refresh = this.refresh.bind(this);
  }

  componentDidMount() {
    this.setState({ loading: true });
    getPersonalDictionary(
      {
        page: 1,
        size: 10,
        sort: this.state.sort,
        order_by: this.state.order_by,
      },
      res => {
        this.setState({
          wordsList: res.list,
          totalCount: res.total_count,
          loading: false,
        });
      },
      e => {
        this.setState({
          wordsList: [],
          totalCount: 0,
          error: e,
          loading: false,
        });
      }
    );
  }

  componentDidUpdate(prevProps) {
    if (this.props.myWordsSearchText !== prevProps.myWordsSearchText) {
      this.refresh(null, this.state.page);
    }
  }

  onModeChanged = mode => () => {
    if (
      this.props.mode === DictionaryMode.TRANSLATE &&
      mode !== DictionaryMode.TRANSLATE
    ) {
      // We need to save the state of translation panel, before changing the mode.
      this.setState({
        translationState: this.translationTool
          ? this.translationTool.getStateToSave()
          : {},
      });
    }
    this.props.onModeChanged(mode);
  };

  toggle = () => {
    this.setState({ dropdownOpen: !this.state.dropdownOpen });
  };

  refresh = (_, pageNumber, sorting) => {
    this.setState({ page: pageNumber, loading: true });
    if (sorting) {
      this.setState({ sort: sorting.sort, order_by: sorting.order_by });
    } else {
      sorting = { sort: this.state.sort, order_by: this.state.order_by };
    }

    getPersonalDictionary(
      {
        page: pageNumber,
        size: ITEMS_PER_PAGE,
        filter: this.props.myWordsSearchText,
        ...sorting,
      },
      res => {
        this.setState({
          wordsList: res.list,
          totalCount: res.total_count,
          loading: false,
        });
      },
      e => {
        this.setState({
          wordsList: [],
          totalCount: 0,
          error: e,
          loading: false,
        });
      }
    );
  };

  onShowSpinner = status => {
    this.setState({ loading: status });
  };

  onDeleteWord = word => {
    if (timerId) {
      clearTimeout(timerId);
    }
    this.setState({
      deletedWord: word,
      openDeletePopup: true,
      selectedPanelId: null,
    });
    this.refresh({}, this.state.page);
    timerId = setTimeout(() => {
      this.setState({
        openDeletePopup: false,
      });
    }, 6000);
  };

  onUpdateNotes = (id, notes) => {
    updateDictionary(
      id,
      {
        notes,
      },
      () => {
        this.setState({
          wordsList: this.state.wordsList.map(word => ({
            ...word,
            notes: word.id === id ? notes : word.notes,
          })),
        });
      },
      e => {
        this.onErrorOccurred(e);
      }
    );
  };

  toggleAddForm = () => {
    if (this.state.addTab) {
      this.refresh({}, this.state.page);
    }

    this.setState({
      addTab: !this.state.addTab,
    });
  };

  onCloseAddForm = () => {
    if (this.state.addTab) {
      this.toggleAddForm();
    }
  };

  onErrorOccurred = e => {
    this.setState({ error: e });
  };

  onOpenSortBy = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  onCloseSortBy = () => {
    this.setState({ anchorEl: null });
  };

  onSortBy = event => {
    if (!event) {
      return;
    }
    const id = event.target.id;
    let sorting;
    if (IDS_TO_SORTING[id] !== undefined) {
      sorting = IDS_TO_SORTING[id].sorting;
    } else {
      logError("Unknown item.id", id);
      return;
    }
    this.setState({ selectedSort: id });
    this.onCloseSortBy();
    this.refresh({}, 1, sorting);
  };

  onChangePanel = (panelId, expanded) => {
    if (expanded) {
      this.setState({ selectedPanelId: panelId });
    } else {
      this.setState({ selectedPanelId: null });
    }
  };

  onToggleWord = () => {
    const item = this.state.wordsList.find(
      ({ word }) => word === this.props.defineContent.word
    );
    if (item) {
      deleteWordFromDictionary(
        item.id,
        () => {
          this.refresh(null, this.state.page);
        },
        err => {
          logError(err);
        }
      );
    } else {
      addWordToDictionary(
        {
          word: this.props.defineContent.word,
          definition: this.props.defineContent.definition,
          translation: this.props.defineContent.translation,
          notes: this.props.defineContent.notes,
        },
        () => {
          this.refresh(null, this.state.page);
        },
        err => {
          logError(err);
        }
      );
    }
  };

  onCloseDeletePopup = () => {
    this.setState({
      openDeletePopup: false,
    });
  };

  undoDelete = () => {
    this.onCloseDeletePopup();
    addWordToDictionary(
      {
        word: this.state.deletedWord.word,
        notes: this.state.deletedWord.notes,
      },
      () => {
        this.refresh(null, this.state.page);
      },
      err => {
        logError(err);
      }
    );
  };

  render() {
    const modes = DictionaryMode.getAllModes().map((m, index) => (
      <Translation>
        {t => (
          <Action
            key={index}
            className={"mode" + (this.props.mode === m ? " active" : "")}
            onClick={this.onModeChanged(m)}
          >
            {t("Tool." + (m === "save" ? "MY VOCAB" : m))}
          </Action>
        )}
      </Translation>
    ));
    let resultPanel = null;
    switch (this.props.mode) {
      case DictionaryMode.DEFINE:
        const selectionBehaviour = (
          <SelectionBehaviour
            isContextMenuOpened={this.props.isSelectionOpened}
            scrollableParentId="dictionary-items"
            positionalParentId="sidebar-id"
            openSidebar={this.props.openSidebar}
            updateParentState={this.props.updateParentState}
          />
        );
        if (this.props.defineContent === null) {
          // Show nothing.
        } else if (typeof this.props.defineContent === "string") {
          resultPanel = (
            <div className="dictionary-items" id="dictionary-items">
              <span>{this.props.defineContent}</span>
              {selectionBehaviour}
            </div>
          );
        } else {
          resultPanel = (
            <div className="dictionary-items" id="dictionary-items">
              <div className="dictionary-word-wrapper">
                <span className="dictionary-word">{this.props.defineContent.word}</span>
                <div className="dictionary-action" onClick={this.onToggleWord}>
                  <img
                    src={
                      this.state.wordsList.find(
                        ({ word }) => word === this.props.defineContent.word
                      )
                        ? bookmarkFilledImg
                        : bookmarkImg
                    }
                    alt="addIcon"
                  />
                </div>
              </div>
              {this.props.defineContent.pos &&
                Object.entries(this.props.defineContent.pos).map(
                  ([pos, entries], index) => (
                    <DictionaryItem
                      key={index}
                      pos={pos}
                      items={entries}
                      word={this.props.defineContent.word}
                      searchText={this.props.searchText}
                    />
                  )
                )}
              {selectionBehaviour}
            </div>
          );
        }
        break;
      case DictionaryMode.TRANSLATE:
        resultPanel = (
          <div className="translate-items" id="translate-items">
            <TranslationTool
              defaultText={this.props.searchText}
              previousState={this.state.translationState}
              ref={tt => (this.translationTool = tt)}
            />
            <SelectionBehaviour
              isContextMenuOpened={this.props.isSelectionOpened}
              scrollableParentId="translate-items"
              positionalParentId="sidebar-id"
              openSidebar={this.props.openSidebar}
              updateParentState={this.props.updateParentState}
            />
          </div>
        );
        break;
      case DictionaryMode.SAVE:
        resultPanel = (
          <Translation>
            {t => (
              <div className="translate-items" id="translate-items">
                <Box
                  display="flex"
                  width="100%"
                  mb={1}
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Box display="flex" alignItems="center">
                    <button
                      className="sort-button"
                      aria-controls="simple-menu"
                      aria-haspopup="true"
                      onClick={this.onOpenSortBy}
                    >
                      <span>
                        <img src={filterListImg} alt="filter-list" />
                      </span>
                      <span>{t(IDS_TO_SORTING[this.state.selectedSort].name)}</span>
                      <span>
                        <ExpandMoreIcon />
                      </span>
                    </button>
                    <Menu
                      id="simple-menu"
                      anchorEl={this.state.anchorEl}
                      keepMounted
                      open={Boolean(this.state.anchorEl)}
                      onClose={this.onCloseSortBy}
                      anchorOrigin={{
                        vertical: "top",
                        horizontal: "left",
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "left",
                      }}
                    >
                      {Object.entries(IDS_TO_SORTING).map(([id, value]) => {
                        return (
                          <MenuItem id={id} onClick={this.onSortBy}>
                            {t(value.name)}
                          </MenuItem>
                        );
                      })}
                    </Menu>
                  </Box>
                  <Box className="save-actions">
                    <button
                      className="practice-button"
                      onClick={() =>
                        this.props.onOpenPracticeVocabDialog(this.state.totalCount)
                      }
                    >
                      <img src={quizIcon} alt="quizIcon" />
                      <span>{t("Tool.Practice")}</span>
                    </button>
                    <button
                      className="new-vocab-button"
                      onClick={this.props.onOpenAddWordDialog}
                    >
                      <img src={addIcon} alt="addIcon" />
                      <span>{t("Tool.New Vocab")}</span>
                    </button>
                  </Box>
                </Box>
                {this.state.error && getErrorComponents(this.state.error)}
                {this.state.addTab && (
                  <div className={"add-word"}>
                    <AddWord
                      onErrorOccurred={this.onErrorOccurred}
                      onClose={this.onCloseAddForm}
                    />
                  </div>
                )}
                {this.state.loading ? (
                  <div className="dictionary-loading">
                    <TalaeraSpinner />
                  </div>
                ) : (
                  <ListWithPagination
                    className="dictionary-paginated-list"
                    total={this.state.totalCount}
                    activePage={this.state.page}
                    schema="page"
                    refresh={this.refresh}
                  >
                    <ul>
                      {this.state.wordsList.map((word, index) => (
                        <SaveWords
                          key={index}
                          {...word}
                          expanded={index === this.state.selectedPanelId}
                          onChangePanel={(_, isExpanded) =>
                            this.onChangePanel(index, isExpanded)
                          }
                          onShowSpinner={this.onShowSpinner}
                          onNotesChange={this.onUpdateNotes}
                          onModeChanged={this.props.onModeChanged}
                          onErrorOccurred={this.onErrorOccurred}
                          onRefresh={() => this.refresh({}, this.state.page)}
                          onDeleteWord={this.onDeleteWord}
                          onTextChanged={this.props.onTextChanged}
                          onOpenExampleDialog={this.props.onOpenExampleDialog}
                        />
                      ))}
                    </ul>
                    {this.state.openDeletePopup && (
                      <div className="delete-toast">
                        <span className="toast-message">
                          <Trans i18nKey="Tool.wasRemove">
                            ‘{{ word: this.state.deletedWord.word }}’ was removed from My
                            Vocab
                          </Trans>
                        </span>
                        <button className="undo-button" onClick={this.undoDelete}>
                          {t("Tool.UNDO")}
                        </button>
                        <button
                          className="close-button"
                          onClick={this.onCloseDeletePopup}
                        >
                          <img src={closeImg} alt="close-icon" />
                        </button>
                      </div>
                    )}
                  </ListWithPagination>
                )}
              </div>
            )}
          </Translation>
        );
        break;
      default:
    }

    return (
      <div className="dictionary-tools-result-panel">
        <div className="select-mode-panel">{modes}</div>
        {this.props.showSpinner && (
          <div className="spinner-container">
            <TalaeraSpinner />
          </div>
        )}
        {!this.props.showSpinner && resultPanel}
      </div>
    );
  }
}

DictionaryToolsResultPanel.propTypes = {
  defaultMode: PropTypes.string,
};
